'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _components2 = require('components');

var _reactBootstrap = require('react-bootstrap');

var _reduxRouter = require('redux-router');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  PublicPlaylistsList: {
    displayName: 'PublicPlaylistsList'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/Playlists/PublicPlaylistsList.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { Collapse } from 'react-bootstrap';


var PublicPlaylistsList = _wrapComponent('PublicPlaylistsList')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps, createDialog: _info.createDialog, updatePlaylist: _docs.updatePlaylist, renamePlaylist: _docs.renamePlaylist, deletePlaylist: _docs.deletePlaylist, setPlaylist: _docs.setPlaylist, dynamicChangePlaylist: _docs.dynamicChangePlaylist, changePlaylistOrder: _docs.changePlaylistOrder, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PublicPlaylistsList, _Component);

  function PublicPlaylistsList() {
    (0, _classCallCheck3.default)(this, PublicPlaylistsList);
    return (0, _possibleConstructorReturn3.default)(this, (PublicPlaylistsList.__proto__ || (0, _getPrototypeOf2.default)(PublicPlaylistsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(PublicPlaylistsList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rows = this.props.playlists.map(function (item, keyIndex) {
        return _react3.default.createElement(
          'tr',
          { key: keyIndex },
          _react3.default.createElement(
            'td',
            null,
            _react3.default.createElement(
              _reactRouter.Link,
              { to: _this2.props.targetRouteFunc(item) },
              item.name
            ),
            ' ',
            _react3.default.createElement(
              'small',
              null,
              '[',
              item.count /*počet pisni*/,
              ']'
            )
          ),
          _react3.default.createElement('td', null)
        );
      });

      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'h1',
          null,
          'Ve\u0159ejn\xE9 playlisty ',
          _react3.default.createElement(
            'small',
            null,
            '[',
            this.props.playlists.length,
            ']'
          )
        ),
        _react3.default.createElement(
          'table',
          { className: 'table table-striped' },
          _react3.default.createElement(
            'tbody',
            null,
            rows
          )
        )
      );
    }
  }]);
  return PublicPlaylistsList;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  authState: _react2.PropTypes.object,
  playlists: _react2.PropTypes.array,
  targetRouteFunc: _react2.PropTypes.func,
  // renamePlaylist: PropTypes.func.isRequired,
  // updatePlaylist: PropTypes.func.isRequired,
  // deletePlaylist: PropTypes.func.isRequired,
  // setPlaylist: PropTypes.func.isRequired,
  // changePlaylistOrder: PropTypes.func.isRequired,
  // dynamicChangePlaylist: PropTypes.func.isRequired,
  // createDialog: PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired
}, _temp)) || _class));

exports.default = PublicPlaylistsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlists/PublicPlaylistsList.js
// module id = 1189
// module chunks = 0